import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import apiLogin from "services/structure/apiLogin";

class Token extends Component {

    state = {
        message: "Estamos validando a tentativa de troca de senha. Aguarde por favor! ",
        severity: "info",
        validated: false
    }

    validarToken = async e => {
        const token = this.props.match?.params?.token;
        try {
            if (token) {
                const response = await apiLogin.post("/user/change-password", { token: token });
                if(response.data?.sucesso) {
                    this.setState({ 
                        message:  response.data.mensagem ,
                        validated: true
                    });
                    return;
                }
                this.setState({ 
                    message:  response.data.mensagem,
                    severity: "error", 
                    validated: true
                });
            }
        } catch (err) {
            const mensagem = err.response?.data?.message ?? err.response?.data?.mensagem ?? "Houve um problema ao tentar se comunicar com o servidor. Por favor, tente novamente mais tarde. " ;
            this.setState({ 
                message:  mensagem,
                severity: "error", 
                validated: true
            });
        }
    }

    render() {
        
        if (!this.state.validated && this.props.tenant) {
            this.validarToken();
        }

        return (
            <div>
                <Alert severity={this.state.severity}>{this.state.message}</Alert>
            </div>
        )
    }

}

const mapStateToProps = store => ({
    tenant: store.layoutState.tenant
});

export default connect(mapStateToProps) (withRouter(Token));